
export default {
  setSnack(state, snack) {
    if (snack.msg.response != undefined) {
      var msg = ''
      if (snack.msg.response.data.errors != undefined) {
        if (typeof (snack.msg.response.data.errors) == 'string') {
          msg = snack.msg.response.data.errors
        }
        else {
          for (var erro in snack.msg.response.data.errors) {
            if (msg == '') {
              msg = snack.msg.response.data.errors[erro].toString()
            }
            else {
              msg = msg + ' ' + snack.msg.response.data.errors[erro].toString()
            }
          }
        }
        state.snack = {
          type: snack.type,
          msg: msg
        }
      }
      else {
        state.snack = {
          type: snack.type,
          msg: snack.msg.response.data[0].value
        }
      }
    }
    else {
      state.snack = snack
    }
  },
  mtChangeToken(state, token) {
    state.token = token
  },
  mtChangeTipoUepDashboard(state, valor) {
    state.csTipoUepDashboard = valor
  },
  mtChangeResponsavelTecnicoDashboard(state, valor) {
    state.cdResponsavelTecnicoDashboard = valor
  },
  mtLoadExtensionistas(state, list) {
    state.extensionistas = list != null ? list : []
  },
  mtChangeLoadingExtensionistas(state, value) {
    state.isLoadingExtensionistas = value
  },
  mtLoadDadosDashboard(state, registros) {
    state.dadosDashboard = registros
    state.isLoadingDadosDashboard = false
  },
  mtChangeLoadingDadosDashboard(state, valor) {
    state.isLoadingDadosDashboard = valor
  },
  mtLoadEstabelecimentos(state, list) {
    state.estabelecimentos = list
  },
  mtChangeLoadingEstabelecimentos(state, value) {
    state.isLoadingEstabelecimentos = value
  },
  mtLoadUFs(state, registros) {
    state.ufs = registros
    state.isLoadingUFs = false
  },
  mtChangeLoadingUFs(state, valor) {
    state.isLoadingUFs = valor
  },
  mtLoadMunicipios(state, registros) {
    state.municipios = registros
    state.isLoadingMunicipios = false
  },
  mtAddMunicipios(state, registros) {
    state.municipios = state.municipios.concat(registros)
    state.isLoadingMunicipios = false
  },
  mtChangeLoadingMunicipios(state, valor) {
    state.isLoadingMunicipios = valor
  },
  mtLoadFabricasRacao(state, list) {
    state.fabricasRacao = list
  },
  mtChangeLoadingFabricasRacao(state, value) {
    state.isLoadingFabricasRacao = value
  },
  mtLoadStatusPedidoRacao(state, registros) {
    state.statusPedidoRacao = registros
    state.isLoadingStatusPedidoRacao = false
  },
  mtChangeLoadingStatusPedidoRacao(state, valor) {
    state.isLoadingStatusPedidoRacao = valor
  },
  mtLoadRacoes(state, list) {
    state.racoes = list
  },
  mtChangeLoadingRacoes(state, value) {
    state.isLoadingRacoes = value
  },
  mtLoadLaboratorios(state, registros) {
    state.laboratorios = registros
    state.isLoadingLaboratorios = false
  },
  mtChangeLoadingLaboratorios(state, valor) {
    state.isLoadingLaboratorios = valor
  },
  mtLoadPrincipiosAtivos(state, registros) {
    state.principiosAtivos = registros
    state.isLoadingPrincipiosAtivos = false
  },
  mtChangeLoadingPrincipiosAtivos(state, valor) {
    state.isLoadingPrincipiosAtivos = valor
  },
  mtLoadPlantasAbate(state, list) {
    state.plantasAbate = list
  },
  mtChangeLoadingPlantasAbate(state, value) {
    state.isLoadingPlantasAbate = value
  },
  mtLoadMotivosBaixa(state, registros) {
    state.motivosBaixa = registros
    state.motivosBaixa.sort(function (a, b) {
      return a.nmMotivoBaixa.localeCompare(b.nmMotivoBaixa);
    });
    state.isLoadingMotivosBaixa = false
  },
  mtChangeLoadingMotivosBaixa(state, valor) {
    state.isLoadingMotivosBaixa = valor
  },
  mtChangeFiltroLoteProducao(state, valor) {
    state.filtroLoteProducao = valor
  },
  mtLoadLotesProducao(state, registros) {
    state.lotesProducao = registros
    state.isLoadingLotesProducao = false
  },
  mtChangeLoadingLotesProducao(state, valor) {
    state.isLoadingLotesProducao = valor
  },
  mtChangeLoteProducaoAtual(state, valor) {
    state.loteProducaoAtual = valor
  },
  mtLoadTabelasConsumoRacao(state, list) {
    state.tabelasConsumoRacao = list
  },
  mtChangeLoadingTabelasConsumoRacao(state, value) {
    state.isLoadingTabelasConsumoRacao = value
  },
  mtLoadTabelaConfiguracao(state, list) {
    state.tabelaConfiguracao = list != null ? list : []
  },
  mtChangeLoadingTabelaConfiguracao(state, value) {
    state.isLoadingTabelaConfiguracao = value
  },
  mtLoadTabelasMetaMortalidade(state, list) {
    state.tabelasMetaMortalidade = list != null ? list : []
  },
  mtChangeLoadingTabelasMetaMortalidade(state, value) {
    state.isLoadingTabelasMetaMortalidade = value
  },
  mtLoadTiposFarmaco(state, registros) {
    state.tiposFarmaco = registros
    state.isLoadingTiposFarmaco = false
  },
  mtChangeLoadingTiposFarmaco(state, valor) {
    state.isLoadingTiposFarmaco = valor
  },
  mtLoadFarmacos(state, list) {
    state.farmacos = list
  },
  mtLoadSinalClinico(state, list) {
    state.lstSinalClinico = list
  },
  mtChangeLoadingTiposCaminhao(state, valor) {
    state.isLoadingTiposCaminhao = valor
  },
  mtLoadTiposCaminhao(state, list) {
    state.tiposCaminhao = list
  },
  mtChangeLoadingFarmacos(state, value) {
    state.isLoadingFarmacos = value
  },
  mtChangeLoadingSinalClinico(state, value) {
    state.isLoadingSinalClinico = value
  },
  mtLoadTiposAdmFarmaco(state, list) {
    state.tiposAdmFarmaco = list
  },
  mtChangeLoadingTiposAdmFarmaco(state, value) {
    state.isLoadingTiposAdmFarmaco = value
  },
}